import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.7_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next/dist/client/image-component.js");
